import { useEffect, useState } from 'react';
import api from '../../api/axios';

const CM = {
  pending:     { bg: 'linear-gradient(135deg,#f59e0b,#fbbf24)', shadow: 'rgba(245,158,11,0.3)' },
  approved:    { bg: 'linear-gradient(135deg,#0d1a6e,#4f6ef7)', shadow: 'rgba(79,110,247,0.3)' },
  rejected:    { bg: 'linear-gradient(135deg,#dc2626,#ef4444)', shadow: 'rgba(220,38,38,0.3)' },
  in_progress: { bg: 'linear-gradient(135deg,#ea580c,#f97316)', shadow: 'rgba(234,88,12,0.3)' },
  completed:   { bg: 'linear-gradient(135deg,#7c3aed,#a78bfa)', shadow: 'rgba(124,58,237,0.3)' },
};

const ITDashboard = () => {
  const [stats, setStats] = useState([]);
  useEffect(() => { api.get('/requests/stats').then(r => setStats(r.data)); }, []);

  return (
    <div>
      <div style={S.banner}>
        <div style={S.bannerBg} />
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={S.bannerTitle}>IT Support Dashboard</div>
          <div style={S.bannerSub}>Every request in the system, whatever its status</div>
        </div>
        <div style={S.blob} />
      </div>
      <div style={S.statsRow}>
        {stats.map(s => {
          const c = CM[s.status] || { bg: 'linear-gradient(135deg,#64748b,#94a3b8)', shadow: 'rgba(0,0,0,0.2)' };
          return (
            <div key={s.status} style={{ ...S.statCard, background: c.bg, boxShadow: `0 8px 24px ${c.shadow}` }}>
              <div style={S.statValue}>{s.count}</div>
              <div style={S.statLabel}>{s.status.replace('_', ' ').toUpperCase()}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const S = {
  banner: {
    background: 'linear-gradient(135deg,#060d3a 0%,#1a0a00 50%,#3a1a00 100%)',
    borderRadius: 18, marginBottom: 28, padding: '32px 36px',
    position: 'relative', overflow: 'hidden',
    boxShadow: '0 8px 32px rgba(6,13,58,0.25)',
  },
  bannerBg: { position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 80% 50%,rgba(234,88,12,0.2) 0%,transparent 60%)' },
  bannerTitle: { color: '#fff', fontSize: 24, fontWeight: 800, marginBottom: 8, letterSpacing: -0.3 },
  bannerSub: { color: 'rgba(255,255,255,0.6)', fontSize: 14 },
  blob: { position: 'absolute', width: 200, height: 200, borderRadius: '50%', background: 'rgba(234,88,12,0.12)', top: -80, right: 60, filter: 'blur(30px)' },
  statsRow: { display: 'flex', gap: 16, flexWrap: 'wrap' },
  statCard: { borderRadius: 16, padding: '22px 28px', minWidth: 150, flex: 1 },
  statValue: { fontSize: 38, fontWeight: 900, color: '#fff', lineHeight: 1, letterSpacing: -1 },
  statLabel: { fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.7)', marginTop: 8, letterSpacing: 1, textTransform: 'uppercase' },
};

export default ITDashboard;
